import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { H3, LI, SVG, UL } from "../../../AbstractElements";
import { AddNewBookmark, Bookmark, Href } from "../../../Constant";
import { useAppDispatch } from "../../../Redux-Toolkit/Hooks";
import { setBookMarkClass } from "../../../Redux-Toolkit/Reducers/BookmarkSlice";

export const BookmarkList = (props: any) => {
  const { bookmarkItems = "" } = props;
  const dispatch = useAppDispatch();
  
  return (
    <div className="front">
      <H3 className="f-18 mb-0 dropdown-title">{Bookmark}</H3>
      <UL className="bookmark-dropdown simple-list">
        <LI>
          <Row>
            {bookmarkItems.map((item: any, index: number) => (
              <Col xs="4" className="text-center mt-1" key={index}>
                <Link to={item.url}>
                  <div className="bookmark-content">
                    <div className="bookmark-icon">
                      <SVG iconId={`stroke-${item.icon1}`} />
                    </div>
                    <span>{item.title}</span>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </LI>
        <LI className="text-centermedia-body check-button" onClick={()=>dispatch(setBookMarkClass())}>
          <a className="flip-btn f-w-500" id="flip-btn" href={Href}>{AddNewBookmark}</a>
        </LI>
      </UL>
    </div>
  );
};
